module.exports = __webpack_public_path__ + "img/18.2cd3c1a4.webp";